import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { summaryTabs } from '../../../routes/sales';

const CollectionReportView = () => {
  const tabs = summaryTabs();
  return <FingoPaper tabs={tabs} />;
};

export default CollectionReportView;
